import { Directive,HostListener,Input} from '@angular/core';

@Directive({
  selector: '[appOnlyAmount]'
})
export class OnlyAmountDirective {

  constructor() {}
  public number:number=null;
  @Input('appOnlyAmount') date:String;
      @HostListener('keypress', ['$event']) onkeypress(ev) {
      let valid=false;
      if(ev.target.value.length<1){

        if((ev.charCode >= 48 && ev.keyCode <= 49 )){
          valid=true;
        }
        if( (ev.charCode == 46 || ev.charCode == 44)){
          valid=true;
        }
        if (!valid){
          ev.preventDefault();
        }
      }

      if(ev.target.value.length>=1){
        if(this.number==1){

          if((ev.charCode >= 48 && ev.keyCode <= 50)){
            valid=true;
          }

          if( (ev.charCode == 46 || ev.charCode == 44)){
            valid=true;
          }
          if (!valid){
            ev.preventDefault();
          }
        }

        if(this.number==0){
          if((ev.charCode >= 49 && ev.keyCode <= 57)){
            valid=true;
          }

          if( (ev.charCode == 46 || ev.charCode == 44)){
            valid=true;
          }
          if (!valid){
            ev.preventDefault();
          }
        }
      }

     }
    @HostListener('blur', ['$event']) onblur(event) {
      if(event.target.value!=undefined && event.target.value!=""){
        if(event.target.value.length>1){

        }
      }
    }

    @HostListener('keyup', ['$event']) onkeyup(event) {
      if(event.target.value!=undefined && event.target.value!=""){
        if(event.target.value[0]=="0"){
          this.number=0;
        }
        if(event.target.value[0]=="1"){
          this.number=1;
        }
      }
    }

}
